import { Controller } from "@hotwired/stimulus"

// Keeps the running timer's display moving. The starting point comes from the
// server (see timers/_card); this only adds the seconds since the page loaded,
// so the phone's own clock never decides what gets saved.
export default class extends Controller {
  static targets = ["display"]
  static values = { elapsed: Number, running: Boolean }

  connect() {
    this.loadedAt = Date.now()
    this.render()
    if (this.runningValue) this.tick = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    clearInterval(this.tick)
  }

  render() {
    const extra = this.runningValue ? Math.floor((Date.now() - this.loadedAt) / 1000) : 0
    const seconds = this.elapsedValue + extra
    const hours = Math.floor(seconds / 3600)
    const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0")
    const rest = String(seconds % 60).padStart(2, "0")
    this.displayTarget.textContent = `${hours}:${minutes}:${rest}`
  }
}
